import * as Factory from 'factory.ts'
import faker from 'faker'

import { CurrencyConstructorFactory } from '@webapp/core/entities/external/Currency/Currency.factory'
import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import { PaymentMethod, type PaymentMethodConstructor } from './PaymentMethod'
import { PaymentMethodTypes } from '../enums/PaymentMethodTypeEnum'

export const PaymentMethodConstructorFactory =
  Factory.Sync.makeFactory<PaymentMethodConstructor>({
    id: Factory.each(() => faker.random.number()),
    name: Factory.each(() => `${faker.finance.accountName()} Account`),
    type: PaymentMethodTypes.ACH,
    currency: Factory.each(() => CurrencyConstructorFactory.build()),
    data: Factory.each(() => ({
      accountNumber: faker.finance.account(),
      routingNumber: faker.finance.account(9),
      companyName: faker.company.companyName(),
    })),
    vendorId: Factory.each(() => faker.random.number()),
    paymentRail: 'ACH',
    bankAccountCountryCode: 'US',
    flightTime: null,
    transactionFee: null,
  })

export const PaymentMethodFactory = EntityFactory(
  PaymentMethod,
  PaymentMethodConstructorFactory
)
